import "./Page.css";

import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import { Link } from "react-router";
import Spinner from "../components/spinner.react";
import Button from "../components/Button.react";
import InputWithError from "../components/inputWithError.react";

export default class Forgot extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    msg: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions, users: { forms } } = this.props;
    actions.clearForm("users", "forgot");
  }

  redirectToLogin = () => {
    const { history } = this.props;
    history.pushState(null, "/");
  };

  onFormSubmit = e => {
    e.preventDefault();
    const { actions, users: { forms }, notificationSystem } = this.props;
    actions.forgot(forms.forgot.fields).then(({ error, payload }) => {
      if (error) {
        focusInvalidField(payload, this, "forgot");
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  };

  render() {
    const { actions, users: { forms }, msg: { users: msg } } = this.props;

    const forgotFormProps = {
      feature: "users",
      actions: actions,
      form: forms.forgot,
      formName: "forgot",
      msg: msg.forms.forgot,
      validateFormField: actions.validateFormFieldUsers
    };

    return (
      <div className="auth-page row center-xs middle-xs">
        <div className="background" />
        <div className="auth-box">
          {!forms.forgot.sent && (
            <div>
              <h1>Fluct</h1>
              <h2>Przypomnij mi hasło</h2>
            </div>
          )}
          {forms.forgot.sent && (
            <div>
              <h1>Udało się!</h1>
              <h4>
                Instrukcje do przywrócenia hasła zostały wysłane na adres{" "}
                {forms.forgot.fields.email}
              </h4>
              <Button
                info
                onClick={this.redirectToLogin}
                text="Powrót do logowania"
              />
            </div>
          )}
          {!forms.forgot.sent && (
            <form onSubmit={this.onFormSubmit} name="forgot" noValidate>
              <InputWithError
                placeholder="Wprowadź email"
                field={"email"}
                type="email"
                {...forgotFormProps}
              />
              <Button
                info
                text="Przypomnij mi hasło"
                disabled={forms.forgot.disabled || !isFormValid(forms.forgot)}
              />
            </form>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/auth/Forgot.react.js